import React from 'react'

import PropTypes from 'prop-types'

import Action from '../Action'

const PrimaryAction: React.FC<any> = (props) => <Action uiComponent="Button" primary {...props} />

PrimaryAction.propTypes = {
  inverted: PropTypes.bool,
}

export default PrimaryAction
